import { useEffect } from 'react';

function BookingSection() {
  useEffect(() => {
    // Load the external script when component mounts
    const script = document.createElement('script');
    script.src = 'https://api.strategysparks.com/js/form_embed.js';
    script.type = 'text/javascript';
    document.body.appendChild(script);

    // Cleanup: remove the script when component unmounts
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="section booking" id="booking" aria-label="booking">
      <div className="container">
        <h2 className="h2 section-title">Free Quick Consult</h2>
        <p className="section-text">Talk goals and success criteria, leave with concrete recommendations.</p>
        <div className="booking-wrapper">
          <iframe src="https://api.strategysparks.com/widget/booking/8Nlg0i3ZV53HpdC6hIWm" style={{ width: '100%', border: 'none', overflow: 'hidden' }} scrolling="no" id="8Nlg0i3ZV53HpdC6hIWm_1761534144410" title="Booking Calendar"></iframe>
        </div>
      </div>
    </section>
  );
}

export default BookingSection;
